const VERSION_SENTINEL = '__CLIENT_ASSET_VERSION__';

export function getLoadedVersion() {
	const v = typeof window !== 'undefined' ? window.__CLIENT_ASSET_VERSION__ : '';
	const trimmed = String(v || '').trim();
	if (!trimmed || trimmed === VERSION_SENTINEL) {
		return '';
	}
	return trimmed;
}

export async function fetchLiveVersion() {
	try {
		const response = await fetch('/client-asset-version.txt', { cache: 'no-store' });
		if (!response.ok) {
			return '';
		}
		return (await response.text()).trim();
	} catch {
		return '';
	}
}

export async function reloadIfClientAssetsStale() {
	if (process.env.NODE_ENV !== 'production') {
		return;
	}

	const loaded = getLoadedVersion();
	if (!loaded) {
		return;
	}

	const live = await fetchLiveVersion();
	if (!live || live === loaded) {
		return;
	}

	window.location.reload();
}

export function isProjectDetailPath(pathname) {
	return /^\/projects\/[^/]+$/.test(pathname || '');
}
